import { cn } from "@/lib/utils";
import styles from "./GlowBorder.module.css";
import { useEffect, useRef, useState } from "react";

export const GlowBorder = ({
  children,
  loading,
  width: initialWidth,
  height: initialHeight,
  borderWidth = 3,
  speed = 8,
  className
}: {
  children: React.ReactNode;
  loading: boolean;
  width?: number;
  height?: number;
  borderWidth?: number;
  speed?: number;
  className?: string;
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(initialWidth);
  const [height, setHeight] = useState(initialHeight);

  useEffect(() => {
    const el = contentRef.current?.childNodes[0] as HTMLElement;

    if (!initialWidth && !initialHeight && el?.clientWidth && el?.clientHeight) {
      setWidth(el.clientWidth);
      setHeight(el.clientHeight);
      el.style.width = `${el.clientWidth - borderWidth * 2}px`;
      el.style.height = `${el.clientHeight - borderWidth * 2}px`;
    }
  }, [contentRef, initialWidth, initialHeight, borderWidth]);

  return (
    <div className={className} style={{ width: `${width}px`, height: `${height}px` }}>
      <div
        className={cn(loading ? styles["animated"] : "", styles["animated-border-box-glow"])}
        style={
          {
            "--glow-border-width": `${borderWidth}px`,
            "--glow-border-speed": `${11 - speed}s`,
            width: `${width}px`,
            height: `${height}px`
          } as React.CSSProperties
        }
      />
      <div
        className={cn(loading ? styles["animated"] : "", styles["animated-border-box"])}
        style={
          {
            "--glow-border-width": `${borderWidth}px`,
            "--glow-border-speed": `${11 - speed}s`,
            width: `${width}px`,
            height: `${height}px`
          } as React.CSSProperties
        }
      >
        <div className={styles["content"]} ref={contentRef}>
          {children}
        </div>
      </div>
    </div>
  );
};
